import { useMediaQuery } from '@/hooks/use-media-query';

/**
 * Custom hook to detect device type based on screen width
 * @returns Object with isMobile, isTablet, and isDesktop boolean flags
 */
export function useDeviceType() {
    const isMobile = useMediaQuery('(max-width: 767px)');
    const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1023px)');
    const isDesktop = !isMobile && !isTablet;

    return {
        isMobile,
        isTablet,
        isDesktop,
    };
}
